"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryNameToISO2 = exports.isValidationPrecisionPass = exports.isGeocodeValidationPrecise = exports.isAddressValidationPrecise = exports.isValidationPass = void 0;
var types_1 = require("../types");
/**
 * Determines if a validated address precision value is a pass.
 * A pass is when precision is one of: ["Manual", "DeliveryPoint", "Premise"].
 * @param precision validated address precision
 * @deprecated
 */
var isValidationPass = function (precision) {
    var passingPrecision = [
        types_1.ISmartyStreetsPrecision.MANUAL,
        types_1.ISmartyStreetsPrecision.PREMISE,
        types_1.ISmartyStreetsPrecision.DELIVERY_POINT,
    ];
    return passingPrecision.includes(precision);
};
exports.isValidationPass = isValidationPass;
/**
 * Determines if a given validated address precision value is a pass.
 * A pass is when precision is one of: ["Manual", "DeliveryPoint", "Premise"].
 * @param precision validated address precision
 */
var isAddressValidationPrecise = function (precision) {
    var passingAddressPrecision = [
        types_1.ISmartyStreetsPrecision.MANUAL,
        types_1.ISmartyStreetsPrecision.PREMISE,
        types_1.ISmartyStreetsPrecision.DELIVERY_POINT,
    ];
    return passingAddressPrecision.includes(precision);
};
exports.isAddressValidationPrecise = isAddressValidationPrecise;
/**
 * Determines if a validated address geocode precision value is a pass.
 * A pass is when precision is one of: ["Manual", "Throughfare", "DeliveryPoint", "Premise"].
 * @param precision validated address geocode precision
 */
var isGeocodeValidationPrecise = function (precision) {
    var passingGeocodePrecision = [
        types_1.ISmartyStreetsPrecision.MANUAL,
        types_1.ISmartyStreetsPrecision.THOROUGHFARE,
        types_1.ISmartyStreetsPrecision.PREMISE,
        types_1.ISmartyStreetsPrecision.DELIVERY_POINT,
    ];
    return passingGeocodePrecision.includes(precision);
};
exports.isGeocodeValidationPrecise = isGeocodeValidationPrecise;
/**
 * Determines if a validated address precision is good enough for our system.
 * @param addressPrecision validated address precision
 * @param geocodePrecision validated address geocode precision
 */
var isValidationPrecisionPass = function (addressPrecision, geocodePrecision) {
    if (addressPrecision === void 0) { addressPrecision = types_1.ISmartyStreetsPrecision.NONE; }
    if (geocodePrecision === void 0) { geocodePrecision = types_1.ISmartyStreetsPrecision.NONE; }
    return (exports.isAddressValidationPrecise(addressPrecision) ||
        exports.isGeocodeValidationPrecise(geocodePrecision));
};
exports.isValidationPrecisionPass = isValidationPrecisionPass;
/**
 * Converts given country name (case-insensitive) to ISO2 format. Supports multiple
 * formats for country names, for ex. Canada, CAN, ca => CA.
 * @param countryName case insensitive country name
 */
var countryNameToISO2 = function (countryName) {
    var normalizedCountryName = countryName === null || countryName === void 0 ? void 0 : countryName.trim().toLowerCase();
    var countryCodes = Object.values(types_1.CountryISO2);
    for (var _i = 0, countryCodes_1 = countryCodes; _i < countryCodes_1.length; _i++) {
        var countryCode = countryCodes_1[_i];
        if (types_1.ISO2CodeToNamesMap[countryCode].has(normalizedCountryName)) {
            return countryCode;
        }
    }
    return null;
};
exports.countryNameToISO2 = countryNameToISO2;
//# sourceMappingURL=LabelHelpers.js.map